import { __assign } from './node_modules/tslib/tslib.es6.js';
import * as React from 'react';

var SvgPause = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "M5 6c0-1.1046.8954-2 2-2s2 .8954 2 2v12c0 1.1046-.8954 2-2 2s-2-.8954-2-2zM15 6c0-1.1046.8954-2 2-2s2 .8954 2 2v12c0 1.1046-.8954 2-2 2s-2-.8954-2-2z" }))); };

export { SvgPause as default };
//# sourceMappingURL=pause.js.map
